
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sk-club/frikd-up-fishies",
      function () {
        return require("private-next-pages/sk-club/frikd-up-fishies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sk-club/frikd-up-fishies"])
      });
    }
  